module.exports = ".mapview {\n  margin-top: 1.5em;\n  width: 100%;\n  height: 87%; }\n"